module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-04-513befa7bec5c9d44fb92c26d1cb84a5.jpg";